<div class="mbs-header mbs-main-menu">
  <nav [class]="'navbar navbar-light mbs-navbar ' + getNavbarButtonsClass()">
    @let isVerticalMenu = navLayout.isVertical();

    <div class="row g-0 navbar-inner align-items-center">
      @if (!isVerticalMenu) {
        <div class="d-flex col-2 col-nav-lg-auto order-nav-1">
          <button
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            class="navbar-toggler mr-2"
            data-target="#navbarSupportedContent"
            data-toggle="collapse"
            type="button"
            (click)="isNavbarCollapsed = !isNavbarCollapsed">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="home-page-area text-center border-end">
            <a
              class="navbar-brand mbs-navbar_brand"
              id="homePageUrl"
              [routerLink]="homePageUrl">
              @let appEnvStateValue = appEnvState();
              @if (appEnvStateValue?.type === 'STAGE') {
                <span
                  class="fa fa-pie-chart text-danger"
                  [title]="appEnvStateValue?.type.toLocaleUpperCase() + ' / ' + appEnvStateValue?.version"></span>
              } @else {
                <span class="fa fa-pie-chart nav-link_ico"></span>
              }
            </a>
          </div>
        </div>
      }

      <!-- TODO: Optimize layout with conditions -->
      @if (!isVerticalMenu) {
        <div
          class="collapse navbar-collapse col-nav-lg-auto order-nav-3 order-nav-lg-2"
          id="navbarSupportedContent"
          [ngbCollapse]="isNavbarCollapsed">
          <ul class="navbar-nav mr-auto">
            @for (item of filterCanMenus(menuItems()); track item.id) {
              @if (item.externalUrl) {
                <li class="nav-item">
                  <a
                    class="fw-semibold nav-link"
                    [href]="item.externalUrl"
                    [target]="item.target || '_self'">
                    <span
                      class="nav-link_ico"
                      [ngClass]="item.iconClass"></span>

                    {{ item.name }}
                  </a>
                </li>
              }

              @if ((!item.children || item.children?.length === 0) && !item.action && !item.externalUrl) {
                @let activeItem = isActiveMenuItem(item);
                <li
                  class="nav-item"
                  [class.active]="activeItem"
                  [class.cursor-default]="activeItem">
                  <a
                    class="nav-link d-inline-flex align-items-center"
                    [queryParams]="item.queryParams"
                    [routerLink]="activeItem ? null : item.routeUrl">
                    <span
                      class="nav-link_ico mr-2"
                      [ngClass]="item.iconClass"></span>

                    <span class="fw-semibold mr-1">
                      {{ item.name }}
                    </span>

                    @if (item.secondIconClass) {
                      <span
                        class="nav-link_ico mr-2"
                        [ngClass]="item.secondIconClass"></span>
                    }

                    @if (item.secondName) {
                      <span class="fw-semibold mr-1">
                        {{ item.secondName }}
                      </span>
                    }
                  </a>
                </li>
              }

              @if (item.action) {
                <li
                  class="nav-item position-relative"
                  [class.mr-2]="item.dotType">
                  <button
                    class="fw-semibold nav-link"
                    [attr.data-e2e]="item.e2eKey || ''"
                    (click)="item.action()">
                    <span
                      class="nav-link_ico mr-2"
                      [ngClass]="item.iconClass"></span>

                    <span
                      class="fw-semibold"
                      [class.app-update-dot]="dot()[item.dotType]"
                      [class.mbs-header-update-dot]="dot()[item.dotType]">
                      {{ item.name }}
                    </span>
                  </button>
                </li>
              }

              @if (item.children?.length > 0) {
                <ng-container *ngTemplateOutlet="itemLevel; context: { item: item, placement: 'bottom-left', isMain: true }"></ng-container>
              }

              <ng-template
                #itemLevel
                let-isMain="isMain"
                let-item="item"
                let-placement="placement">
                <li
                  display="dynamic"
                  ngbDropdown
                  [class.active]="isActiveMenuClass(item)"
                  [class.mbs-header-integrations-dropdown]="!isMain"
                  [class]="isMain ? 'nav-item' : 'nav-submenu-link'"
                  [container]="null"
                  [placement]="placement">
                  @let activeSubTitle = isMain && getActiveSubTitle(item);

                  @if (!activeSubTitle) {
                    <button
                      class="d-inline-flex align-items-center"
                      ngbDropdownToggle
                      [class]="isMain ? 'nav-link' : 'w-100 nav-submenu-link px-0 py-1'"
                      [id]="item.name.toLowerCase()">
                      <span
                        class="nav-link_ico mr-2"
                        [ngClass]="item.iconClass"></span>

                      <span
                        class="mr-1"
                        [class.app-update-dot]="dot()[item.dotType]"
                        [class.mbs-header-update-dot]="dot()[item.dotType]"
                        [class]="isMain ? 'fw-semibold' : 'fw-normal'">
                        {{ item.name }}
                      </span>

                      @if (item.secondIconClass) {
                        <span
                          class="nav-link_ico mr-2"
                          [ngClass]="item.secondIconClass"></span>
                      }

                      @if (item.secondName) {
                        <span class="fw-semibold mr-1">
                          {{ item.secondName }}
                        </span>
                      }
                    </button>
                  } @else {
                    <button
                      class="nav-link -sublink"
                      ngbDropdownToggle
                      [id]="item.name.toLowerCase()">
                      <span class="d-inline-flex align-items-center flex-row">
                        <span
                          class="nav-link_ico"
                          [ngClass]="getParentIcon(item)"></span>

                        <span class="d-block mx-1">
                          <span
                            class="fw-semibold nav-link_parent"
                            [class.app-update-dot]="dot()[item.dotType]"
                            [class.mbs-header-active-dot]="dot()[item.dotType]">
                            {{ item.name }}&nbsp;{{ item.secondName }}
                          </span>

                          <span class="fw-semibold d-block">
                            {{ getActiveSubTitle(item) }}
                          </span>
                        </span>
                      </span>
                    </button>
                  }

                  <ul
                    class="nav-submenu -rel-sm"
                    ngbDropdownMenu
                    [attr.aria-labelledby]="item.name.toLowerCase()">
                    @for (child of filterCanMenus(item.children); track child.id) {
                      @if (child.isHorizontalDivider) {
                        <hr class="header-menu-hr" />
                      }

                      @if (!child.children && !child.isHorizontalDivider && child.can === true) {
                        @let activeChild = isActiveMenuItem(child);
                        <li
                          class="nav-submenu-item"
                          ngbDropdownItem
                          [class.active]="activeChild"
                          [class.cursor-default]="activeChild">
                          @if (child.routeUrl) {
                            <a
                              class="nav-submenu-link"
                              [queryParams]="child.queryParams"
                              [routerLink]="activeChild ? null : child.routeUrl"
                              (click)="hideDot(child.dotType)">
                              <span
                                class="nav-link_ico"
                                [ngClass]="child.iconClass"></span>

                              <span
                                [class.app-update-dot]="dot()[child.dotType]"
                                [class.mbs-header-child-dot]="dot()[child.dotType]">
                                {{ child.name }}
                              </span>
                            </a>
                          }

                          @if (child.externalUrl) {
                            <a
                              class="nav-submenu-link"
                              [href]="child.externalUrl"
                              [target]="child.target || '_self'"
                              (click)="hideDot(child.dotType)">
                              <span
                                class="nav-link_ico"
                                [ngClass]="child.iconClass"></span>

                              <span
                                [class.app-update-dot]="dot()[child.dotType]"
                                [class.mbs-header-child-dot]="dot()[child.dotType]">
                                {{ child.name }}
                              </span>
                            </a>
                          }

                          @if (!item.isHorizontalDivider && child.action) {
                            <button
                              class="nav-submenu-link"
                              (click)="hideDot(child.dotType); child.action()">
                              <span
                                class="nav-link_ico"
                                [ngClass]="child.iconClass"></span>

                              <span
                                [class.app-update-dot]="dot()[child.dotType]"
                                [class.mbs-header-child-dot]="dot()[child.dotType]">
                                {{ child.name }}
                              </span>
                            </button>
                          }
                        </li>
                      }

                      @if (child.children?.length > 0) {
                        <ng-container
                          *ngTemplateOutlet="
                            itemLevel;
                            context: { item: child, placement: ['right-top', 'bottom-right'], isMain: false }
                          "></ng-container>
                      }
                    }
                  </ul>
                </li>
              </ng-template>
            }
          </ul>
        </div>
      }

      @let allowHelpMarketing = Permissions.HelpMarketing | can: 'read';

      <div
        class="d-flex col-nav-lg-auto order-nav-2 order-nav-lg-3"
        [class.col-10]="!isVerticalMenu"
        [class.col-12]="isVerticalMenu"
        [class.justify-content-between]="isVerticalMenu"
        [class.justify-content-end]="!isVerticalMenu">
        @if (isVerticalMenu) {
          <div class="d-flex g-0 align-items-center">
            <ng-container *ngTemplateOutlet="addButton"></ng-container>
            <ng-container *ngTemplateOutlet="tryRmmButton"></ng-container>
          </div>
        }

        <div class="d-flex g-0 align-items-center justify-content-end">
          @if (!isVerticalMenu) {
            <ng-container *ngTemplateOutlet="tryRmmButton"></ng-container>
          }

          @if (!isVerticalMenu) {
            <ng-container *ngTemplateOutlet="balanceButton"></ng-container>
            <ng-container *ngTemplateOutlet="addButton"></ng-container>
          }

          @if (allowHelpMarketing && !('HideFeedback' | can: 'read')) {
            <div class="navbar-btn-collapse">
              <button
                class="btn btn-light mr-2"
                data-badge-changelog
                data-sleek-changelog
                [class.btn-rounded]="isVerticalMenu"
                [class.btn-sm]="isVerticalMenu"
                [class.fw-bold]="!isVerticalMenu"
                [class.mbs-header-topbar-btn]="isVerticalMenu">
                @if (isVerticalMenu) {
                  <span class="fa fa-bullhorn text-base"></span>
                  {{ 'shared:header.buttons.news' | i18next }}
                } @else {
                  <span class="fa fa-bell"></span>
                }
              </button>
            </div>
          }

          @let messagesCount = unreadSupportMessagesCount();

          @if (allowHelpMarketing) {
            <mbs-dropdown-button
              class="mr-2"
              [customClasses]="isVerticalMenu ? 'mbs-header-topbar-btn' : 'fw-bold'"
              [dropdownContainer]="null"
              [dropdownPlacement]="'bottom-right bottom-left'"
              [dropdownTemplate]="helpMenu"
              [id]="'dropdownBasic1'"
              [rounded]="isVerticalMenu"
              [size]="isVerticalMenu ? MbsSize.sm : null"
              [type]="'light'">
              @if (isVerticalMenu) {
                <span class="fa fa-question-circle-o text-base"></span>
                {{ 'shared:buttons.help' | i18next }}
              } @else {
                <span class="nav-link_ico fa fa-question-circle"></span>
              }

              @if (!!messagesCount) {
                <span
                  class="bg-danger text-white mbs-header_unread-circle"
                  [class.-topbar]="isVerticalMenu"
                  [class.border-radius-sm-important]="!isVerticalMenu"
                  [class.rounded-circle]="isVerticalMenu">
                  {{ messagesCount }}
                </span>
              }
              @if (!messagesCount && dot()[DotType.Help]) {
                <span
                  class="app-update-dot"
                  [class.mbs-header-help-dot]="!isVerticalMenu"
                  [class.mbs-header-topbar-dot]="isVerticalMenu"></span>
              }
            </mbs-dropdown-button>

            <ng-template #helpMenu>
              <ul class="nav-submenu list-unstyled">
                @if (errorHandlerService.isDebug) {
                  <li class="nav-submenu-item dropdown-item-text">
                    <mbs-switcher
                      class="nav-submenu-link right-submenu"
                      [label]="'Enable toasts'"
                      [selected]="!isToastDisabled()"
                      (afterUpdate)="handleChangeToastVisibility($event)"></mbs-switcher>
                  </li>
                }

                @for (item of filterCanMenus(helpMenuItems); track item.id) {
                  <li
                    class="nav-submenu-item dropdown-item"
                    ngbDropdownItem
                    [class.mr-2]="item.dotType && item.dotSubType !== DotSubType.New">
                    @if (item.routeUrl) {
                      <a
                        class="nav-submenu-link right-submenu"
                        ngbDropdownItem
                        [routerLink]="item.routeUrl"
                        [target]="item.target || '_self'"
                        [title]="item.title">
                        <span
                          class="nav-link_ico"
                          [ngClass]="item.iconClass"></span>

                        <span
                          [class.app-update-dot]="dot()[item.dotType] && item.dotSubType !== DotSubType.New"
                          [class.mbs-header-child-dot]="dot()[item.dotType] && item.dotSubType !== DotSubType.New">
                          {{ item.name }}
                        </span>
                        @if (dot()[item.dotType] && item.dotSubType === DotSubType.New) {
                          <span class="ml-2 new-dot-badge text-white fw-bold text-xs">{{
                            ('shared:common.new' | i18next).toUpperCase()
                          }}</span>
                        }
                      </a>
                    }

                    @if (item.externalUrl) {
                      <a
                        class="nav-submenu-link right-submenu"
                        ngbDropdownItem
                        [href]="item.externalUrl"
                        [target]="item.target || '_self'"
                        [title]="item.title"
                        (click)="hideDot(item.dotType)">
                        <span
                          class="nav-link_ico"
                          [ngClass]="item.iconClass"></span>

                        <span
                          [class.app-update-dot]="dot()[item.dotType] && item.dotSubType !== DotSubType.New"
                          [class.mbs-header-child-dot]="dot()[item.dotType] && item.dotSubType !== DotSubType.New">
                          {{ item.name }}
                        </span>
                        @if (dot()[item.dotType] && item.dotSubType === DotSubType.New) {
                          <span class="ml-2 new-dot-badge text-white fw-bold text-xs">{{
                            ('shared:common.new' | i18next).toUpperCase()
                          }}</span>
                        }
                      </a>
                    }

                    @if (item.action) {
                      <button
                        class="nav-submenu-link right-submenu d-flex justify-content-between align-items-center"
                        ngbDropdownItem
                        [title]="item.title"
                        (click)="item.action()">
                        <span>
                          <span
                            class="nav-link_ico"
                            [ngClass]="item.iconClass"></span>

                          <span
                            class="d-inline-block align-top"
                            [class.app-update-dot]="dot()[item.dotType] && item.dotSubType !== DotSubType.New"
                            [class.mbs-header-child-dot]="dot()[item.dotType] && item.dotSubType !== DotSubType.New">
                            {{ item.name }}
                            @if (item.id === 'support' && messagesCount) {
                              <mbs-tag
                                [active]="true"
                                [class]="'ml-1 bg-danger border-radius-sm-important text-uppercase text-xs text-white fw-bold'"
                                [clickable]="false"
                                [closable]="false"
                                [noBorder]="true"
                                [size]="MbsSize.sm">
                                {{ messagesCount }}
                              </mbs-tag>
                            }
                            @if (item.subName) {
                              <span class="d-block text-xs text-gray-600">{{ item.subName }}</span>
                            }
                          </span>
                          @if (dot()[item.dotType] && item.dotSubType === DotSubType.New) {
                            <span class="ml-2 new-dot-badge text-white fw-bold text-xs">{{
                              ('shared:common.new' | i18next).toUpperCase()
                            }}</span>
                          }
                        </span>

                        @if (item.actionButton) {
                          <mbs-button
                            class="ml-3"
                            type="primary"
                            [id]="item.actionButton.id"
                            [size]="MbsSize.xs"
                            (click)="$event.stopPropagation(); item.actionButton.action()">
                            {{ item.actionButton.label }}
                          </mbs-button>
                        }
                      </button>
                    }
                  </li>
                }
              </ul>
            </ng-template>
          }

          @if (isVerticalMenu) {
            <ng-container *ngTemplateOutlet="balanceButton"></ng-container>
          }

          @let user = currentUser();
          @if (user) {
            <mbs-dropdown-button
              [customClasses]="isVerticalMenu ? 'mbs-header-topbar-btn' : 'fw-bold'"
              [dropdownContainer]="null"
              [dropdownPlacement]="'bottom-right bottom-left'"
              [dropdownTemplate]="userMenu"
              [id]="'dropdownUser'"
              [rounded]="isVerticalMenu"
              [size]="isVerticalMenu ? MbsSize.sm : null"
              [type]="'light'"
              (click)="hideDot(DotType.MainUser)">
              @if (isVerticalMenu) {
                <span
                  class="mbs-header-btn-ico -accent d-inline-flex align-items-center justify-content-center rounded-circle"
                  [class.mbs-premium-ring]="isPremiumSupportEnabled()">
                  @if (user?.IsProvider) {
                    <span
                      class="ico ico-crown text-xs header-nav-link-user-ico"
                      [class.-reseller]="!!user?.ResellerInfo"
                      [class.text-danger]="user?.IsSuperAdmin"
                      [class.text-yellow]="!user?.IsSuperAdmin"></span>
                  } @else {
                    <span
                      class="ico ico-Contact text-xs header-nav-link-user-ico"
                      [class.-reseller]="!!user?.ResellerInfo"
                      [class.text-danger]="user?.IsSuperAdmin"
                      [class.text-purple]="!user?.IsSuperAdmin"></span>
                  }
                </span>

                {{ (user?.IsProvider ? 'shared:header.texts.serviceProvider' : 'shared:header.texts.administrator') | i18next }}

                @if (dot()[DotType.MainUser]) {
                  <span class="app-update-dot mbs-header-topbar-dot"></span>
                }
              } @else {
                <span
                  class="nav-link_ico header-nav-link-user-ico fa fa-user-circle-o"
                  [class.-reseller]="!!user?.ResellerInfo"
                  [class.app-update-dot]="dot()[DotType.MainUser]"
                  [class.mbs-header-user-update-dot]="dot()[DotType.MainUser]"
                  [class.mbs-premium-ring]="isPremiumSupportEnabled()"
                  [class.text-danger]="user?.IsSuperAdmin"
                  [class.text-purple]="!user?.IsProvider && !user?.IsSuperAdmin"
                  [class.text-success]="user?.IsProvider && !user?.IsSuperAdmin"></span>
              }
            </mbs-dropdown-button>

            <ng-template #userMenu>
              <ul class="nav-submenu list-unstyled">
                <li
                  class="mbs-navbar_userinfo-item"
                  disabled="true">
                  @if (user?.IsProvider) {
                    <div class="mt-1 mb-2">
                      <span class="ico ico-crown text-yellow"></span>
                      <span class="ml-2 text-gray-900">{{ 'shared:header.texts.serviceProvider' | i18next }}</span>
                    </div>
                  } @else {
                    <div class="mt-1 mb-2">
                      <span class="mbs-navbar_admin-icon ico ico-User text-white background-gray"></span>
                      <span class="ml-2 text-gray-900">{{ 'shared:header.texts.administrator' | i18next }}</span>
                    </div>
                  }

                  <div class="text-xs fw-bold mb-1">
                    {{ 'shared:header.texts.you' | i18next }}
                  </div>

                  @if (user?.displayName) {
                    <div class="text-sm mb-1">
                      {{ user?.displayName }}
                    </div>
                  }

                  <div class="text-sm mb-1">{{ user?.ProviderInfo?.CompanyName }}</div>

                  @if (user?.Email) {
                    <div class="text-sm">
                      {{ user?.Email }}
                    </div>
                  }
                </li>

                @let manager = accountManager();

                @if (manager && allowHelpMarketing) {
                  @if (manager?.fullPhotoUrl) {
                    <li class="dropdown-divider mb-0"></li>

                    <li
                      class="mbs-navbar_userinfo-item bg-blue-10 py-2"
                      disabled="true">
                      <div class="row g-0">
                        <div class="col d-flex align-items-center">
                          <div
                            class="account-manager-photo"
                            [ngStyle]="{ 'background-image': 'url(' + getAccountManagerPhotoURL() + ')' }"></div>
                        </div>

                        <div class="col d-flex align-items-center">
                          <div>
                            <div class="row">
                              <div class="col text-xs fw-bold mb-1">
                                {{ 'shared:header.texts.personalAccountManager' | i18next }}
                              </div>
                            </div>

                            <div class="row">
                              <div class="col text-sm">
                                {{ manager?.name }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li class="dropdown-divider my-0"></li>

                    <li
                      class="mbs-navbar_userinfo-item bg-blue-10 py-2"
                      disabled="true">
                      @if (manager?.phone) {
                        <div class="text-sm mb-1">
                          {{ manager?.phone }}
                        </div>
                      }

                      <button
                        class="nav-link right-submenu text-sm px-0 py-0"
                        container="body"
                        placement="top-left auto"
                        [ngbTooltip]="'shared:header.tooltip.copyEmail' | i18next"
                        (click)="handleCopyAccountManagerEmail()">
                        {{ manager?.email }}
                      </button>
                    </li>
                  } @else {
                    <li class="dropdown-divider mb-0"></li>

                    <li
                      class="mbs-navbar_userinfo-item bg-blue-10 py-2 bg-ico-container"
                      disabled="true">
                      <i class="ico ico-Briefcase bg-ico text-primary"></i>

                      <div class="text-xs fw-bold mb-1">
                        {{ 'shared:header.texts.personalAccountManager' | i18next }}
                      </div>

                      <div class="text-sm mb-1">
                        {{ manager?.name }}
                      </div>

                      <button
                        class="nav-link right-submenu text-sm px-0 py-0"
                        container="body"
                        placement="top-left auto"
                        [ngbTooltip]="'shared:header.tooltip.copyEmail' | i18next"
                        (click)="handleCopyAccountManagerEmail()">
                        {{ manager?.email }}
                      </button>

                      @if (manager?.phone) {
                        <div class="text-sm mt-1">
                          {{ manager?.phone }}
                        </div>
                      }
                    </li>
                  }
                }

                <li
                  class="dropdown-divider"
                  [class.mt-0]="!!manager && allowHelpMarketing"></li>

                @if (!user?.IsProvider) {
                  <li
                    class="nav-submenu-item"
                    ngbDropdownItem>
                    <button
                      class="nav-link right-submenu py-1"
                      (click)="handleMyProfile()">
                      <span class="nav-link_ico fa fa-cloud"></span>

                      {{ 'shared:header.buttons.myProfile' | i18next }}
                    </button>
                  </li>

                  <li class="dropdown-divider"></li>
                }

                @if (allowManagePaymentMethods()) {
                  <li
                    class="nav-submenu-item"
                    ngbDropdownItem
                    [attr.data-e2e]="elementSelectors.name.paymentMethodsInfo">
                    <button
                      class="nav-link right-submenu py-1"
                      (click)="managePaymentMethods()">
                      <span>
                        <span class="nav-link_ico ico ico-wallet"></span>

                        <span class="d-inline-block align-top text-start">
                          {{ 'shared:buttons.payMethods' | i18next }}
                          @if (!licenseModeNone()) {
                            <mbs-license-mode-label
                              class="d-block text-xxs text-gray-600"
                              [attr.data-e2e]="elementSelectors.name.paymentMethodsInfoSubtitle" />
                          }
                        </span>
                      </span>
                    </button>
                  </li>

                  <li
                    class="dropdown-divider"
                    [attr.data-e2e]="elementSelectors.name.paymentMethodsInfoDivider"></li>
                }
                <li
                  class="nav-submenu-item"
                  ngbDropdownItem>
                  <button
                    class="nav-link right-submenu py-1"
                    (click)="handleLogout()">
                    <span class="nav-link_ico fa fa-sign-out"></span>

                    {{ 'shared:buttons.logOut' | i18next }}
                  </button>
                </li>
              </ul>
            </ng-template>
          }
        </div>
      </div>
    </div>
  </nav>
</div>

@if (!navLayout.isVertical()) {
  <div class="mbs-header">
    <nav class="navbar mbs-navbar empty-navbar"></nav>
  </div>
}

@defer {
  <mbs-sleekplan-loader></mbs-sleekplan-loader>
}

<ng-template #balanceButton>
  @if (showBalanceBtn()) {
    @let isVerticalMenu = navLayout.isVertical();
    @let currentBalance = balance();
    @if (isVerticalMenu) {
      <mbs-button
        class="mr-2"
        [customClasses]="'mbs-header-topbar-btn'"
        [rounded]="true"
        [size]="MbsSize.sm"
        (click)="currentBalance?.hasDebt ? openPaymentModal(true) : openPaymentModal()">
        <span class="mbs-header-btn-ico d-inline-flex align-items-center justify-content-center rounded-circle">
          <span class="ico ico-wallet text-xs"></span>
        </span>

        <span [class.text-danger]="currentBalance?.hasDebt"
          >{{ currentBalance?.hasDebt ? '-' : '' }}{{ currentBalance?.subscriptionCurrencySign
          }}{{ currentBalance?.balanceValue | number: '1.0-2' }}</span
        >
      </mbs-button>
    } @else {
      <div class="mr-3">
        <span>
          {{ 'shared:licenses.balance' | i18next: { format: 'title' } }}
        </span>

        <mbs-button
          [customClasses]="'fw-semibold'"
          [isCtrl]="true"
          [type]="currentBalance?.hasDebt ? 'danger' : 'dark'"
          (click)="currentBalance?.hasDebt ? openPaymentModal(true) : openPaymentModal()">
          <span
            >{{ currentBalance?.hasDebt ? '-' : '' }}{{ currentBalance?.subscriptionCurrencySign
            }}{{ currentBalance?.balanceValue | number: '1.0-2' }}</span
          >
        </mbs-button>
      </div>
    }
  }
</ng-template>

<ng-template #tryRmmButton>
  @if (showTryRMMBtn()) {
    @let isVerticalMenu = navLayout.isVertical();
    <mbs-button
      class="mr-3"
      [customClasses]="isVerticalMenu ? 'mbs-header-try-rmm-btn' : 'text-white'"
      [rounded]="isVerticalMenu"
      [size]="isVerticalMenu ? MbsSize.sm : null"
      [type]="'warning'"
      (click)="handleRMMGettingStartedWizard()">
      @if (isVerticalMenu) {
        <span class="ico ico-rmm-agent"></span>
      }
      {{ 'shared:header.buttons.tryRMM' | i18next }}
    </mbs-button>
  }
</ng-template>

<ng-template #addButton>
  @if (showAddBtn()) {
    @let isVerticalMenu = navLayout.isVertical();
    <mbs-dropdown-button
      [class.mr-2]="isVerticalMenu"
      [class.mr-3]="!isVerticalMenu"
      [customClasses]="'mbs-header-add-btn'"
      [dropdownContainer]="null"
      [dropdownHideIcon]="isVerticalMenu"
      [dropdownPlacement]="'bottom-right bottom-left'"
      [dropdownTemplate]="addMenu"
      [id]="'dropdownAdd'"
      [rounded]="isVerticalMenu"
      [size]="isVerticalMenu ? MbsSize.sm : null"
      [type]="'success'">
      <span class="fa fa-plus"></span>

      {{ (isVerticalMenu ? 'shared:buttons.addNewItem' : 'shared:buttons.add') | i18next }}
    </mbs-dropdown-button>

    <ng-template #addMenu>
      <ul class="nav-submenu list-unstyled">
        @for (item of filterCanMenus(addMenuItems); track item.id) {
          <li
            class="nav-submenu-item dropdown-item"
            ngbDropdownItem>
            @if (item.routeUrl) {
              <a
                class="nav-submenu-link right-submenu"
                ngbDropdownItem
                [queryParams]="item.queryParams"
                [routerLink]="item.routeUrl"
                [target]="item.target || '_self'">
                <span
                  class="nav-link_ico"
                  [ngClass]="item.iconClass"></span>

                {{ item.name }}
              </a>
            }

            @if (item.externalUrl) {
              <a
                class="nav-submenu-link right-submenu"
                ngbDropdownItem
                [href]="item.externalUrl"
                [target]="item.target || '_self'">
                <span
                  class="nav-link_ico"
                  [ngClass]="item.iconClass"></span>

                {{ item.name }}
              </a>
            }

            @if (item.action) {
              <button
                class="nav-submenu-link right-submenu"
                ngbDropdownItem
                (click)="item.action()">
                <span
                  class="nav-link_ico"
                  [ngClass]="item.iconClass"></span>

                {{ item.name }}
              </button>
            }
          </li>
        }
      </ul>
    </ng-template>
  }
</ng-template>
